import type { ArtefactSummary } from './api.ts'

export type Department = { slug: string; name: string }

/** The brief's seven function-based departments. Order is the display order. */
export const DEPARTMENTS: Department[] = [
  { slug: 'governance-compliance', name: 'Governance & Compliance' },
  { slug: 'people-culture', name: 'People & Culture' },
  { slug: 'child-safety', name: 'Child Safety' },
  { slug: 'health-safety-wellbeing', name: 'Health, Safety & Wellbeing' },
  { slug: 'educational-leadership', name: 'Educational Leadership' },
  { slug: 'family-community-engagement', name: 'Family & Community Engagement' },
  { slug: 'finance-operations', name: 'Finance & Operations' },
]

export const departmentBySlug = (slug: string) => DEPARTMENTS.find((d) => d.slug === slug)
export const slugForDepartment = (name: string) =>
  DEPARTMENTS.find((d) => d.name === name)?.slug ?? ''

/**
 * An artefact belongs to a department by its primary `department` field, or
 * secondarily by a `department`-dimension tag — the tie-breaker rule: surfaced
 * in both places, stored once. Shared by HubLanding's count and DepartmentPage's
 * filter so the two views can never disagree about what a department contains.
 */
export const belongsToDepartment = (a: ArtefactSummary, department: Department) =>
  a.department === department.name ||
  a.tags.some((t) => t.dimension === 'department' && t.value === department.name)
